import React from 'react'

type BbqProps = {
  className?: string
}

const _Bbq = (props: BbqProps) => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2C10.5523 2 11 2.44772 11 3C11 3.55228 10.5523 4 10 4C8.34315 4 7 5.34315 7 7C7 7.35064 7.06015 7.68722 7.17071 8H0C0 8.68142 0.0567976 9.34958 0.165917 10C0.790978 13.7257 3.13285 16.8693 6.35026 18.5895L3.80384 23H6.11324L8.19988 19.3858C9.3941 19.7842 10.6719 20 12 20C13.3281 20 14.6059 19.7842 15.8001 19.3858L17.8868 23H20.1962L17.6497 18.5895C20.8671 16.8693 23.209 13.7257 23.8341 10C23.9432 9.34958 24 8.68142 24 8H16C15.4477 8 15 7.55228 15 7C15 6.44772 15.4477 6 16 6C16.8885 6 17.6868 5.61375 18.2361 5C18.7111 4.46924 19 3.76835 19 3C19 1.34315 17.6569 0 16 0V2C16.5523 2 17 2.44772 17 3C17 3.55228 16.5523 4 16 4C14.3431 4 13 5.34315 13 7C13 7.35064 13.0602 7.68722 13.1707 8H10C9.44772 8 9 7.55228 9 7C9 6.44772 9.44772 6 10 6C10.8885 6 11.6868 5.61375 12.2361 5C12.7111 4.46924 13 3.76835 13 3C13 1.34315 11.6569 0 10 0V2ZM2.20004 10H10H16H21.8C20.8734 14.5645 16.8379 18 12 18C7.16208 18 3.12658 14.5645 2.20004 10Z"
      fill="currentColor"
    />
  </svg>
)

export default React.memo(_Bbq)
